import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const uploadDiplomeImageApi = createAsyncThunk(
  "diplome/uploadImage",
  async (imageData) => {
    const token = JSON.parse(localStorage.getItem("userData")).token;
    var formData = new FormData();
    formData.append("image", imageData.imagefile);

    return await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/diplome/update-image/${imageData.diplomeId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((resule) => resule)
      .catch((err) => err);
  }
);

const UpdateImageDiplomeSlicer = createSlice({
  name: "diplome/image",
  initialState: {
    loading: false,
    response: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(uploadDiplomeImageApi.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(uploadDiplomeImageApi.fulfilled, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    });
    builder.addCase(uploadDiplomeImageApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default UpdateImageDiplomeSlicer.reducer;
